// extracted by mini-css-extract-plugin
export default {"component":"Radio_component__YOmaT","disabled":"Radio_disabled__w50Gd","checked":"Radio_checked__SXADx"};